import { useSyncExternalStore } from "react";

/**
 * Returns the actual visible viewport height in pixels, accounting for
 * mobile URL bar show/hide and virtual keyboard open/close.
 *
 * Uses window.visualViewport when available (all modern mobile browsers),
 * falling back to window.innerHeight for older browsers / SSR.
 *
 * The value is returned as a CSS length string (e.g. "812px") so it can
 * be used directly in inline styles.
 */
function subscribe(callback: () => void) {
  const vv = window.visualViewport;
  if (vv) {
    vv.addEventListener("resize", callback);
    return () => vv.removeEventListener("resize", callback);
  }
  window.addEventListener("resize", callback);
  return () => window.removeEventListener("resize", callback);
}

function getSnapshot(): string {
  const vv = window.visualViewport;
  return vv ? `${vv.height}px` : `${window.innerHeight}px`;
}

function getServerSnapshot(): string {
  return "100vh";
}

export function useViewportHeight(): string {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}